import { create } from 'zustand';
import type { RunningStatus } from '@/types/automation';

export type ApplicationTransitionTarget = Extract<RunningStatus, 'Running' | 'Stopped'>;

export interface ApplicationTransitionIntent {
  target: ApplicationTransitionTarget;
  expiresAt: number;
}

interface ApplicationTransitionState {
  transitions: Record<string, ApplicationTransitionIntent>;
  setTransition: (key: string, transition: ApplicationTransitionIntent) => void;
  clearTransition: (key: string, expected?: ApplicationTransitionIntent) => void;
  resetTransitions: () => void;
}

export const getApplicationTransitionKey = (projectName: string, appName: string): string =>
  JSON.stringify([projectName.toLowerCase(), appName.toLowerCase()]);

export const useApplicationTransitionStore = create<ApplicationTransitionState>((set) => ({
  transitions: {},
  setTransition: (key, transition) =>
    set((state) => ({
      transitions: {
        ...state.transitions,
        [key]: transition,
      },
    })),
  clearTransition: (key, expected) =>
    set((state) => {
      const current = state.transitions[key];
      if (
        !current ||
        (expected && (current.target !== expected.target || current.expiresAt !== expected.expiresAt))
      ) {
        return {};
      }

      const transitions = { ...state.transitions };
      delete transitions[key];
      return { transitions };
    }),
  resetTransitions: () => set({ transitions: {} }),
}));
